import { Fragment } from 'react'
import { NavLink } from 'react-router-dom'
import { useSignOut, useIsAuthenticated, useAuthHeader, useAuthUser } from 'react-auth-kit'
import axios from 'axios'
import logo from '../../logo.svg'
import { 
  // Disclosure, 
  Menu, Popover, Transition } from '@headlessui/react'
import {
  HomeIcon,
  // BookmarkAltIcon,
  // CalendarIcon,
  // ChartBarIcon,
  // CursorClickIcon,
  MenuIcon,
  // PhoneIcon,
  // PlayIcon,
  // RefreshIcon,
  // ShieldCheckIcon,
  // SupportIcon,
  // ViewGridIcon,
  XIcon,
  LogoutIcon,
  LoginIcon,
  TerminalIcon,
} from '@heroicons/react/outline'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Header() {
  const signOut = useSignOut()
  const isAuthenticated = useIsAuthenticated()
  const auth  = useAuthHeader()
  const authUser = useAuthUser()

  const meniuLinks = [
    {
      name: 'Pagrindinis',
      description: 'Eiti į pagrindinį',
      to: '/',
      icon: HomeIcon,
    },
    ...isAuthenticated() ? [{
      name: 'Skydelis',
      description: 'Eiti į prietaisų skydelį',
      to: '/dashboard',
      icon: TerminalIcon,
    }] : [],
  ]

  const logOut = () => {
    const config = {
      headers: {
        Authorization: auth()
      }
    }
    axios.post(process.env.REACT_APP_API + '/auth/logout', '', config)
      .then((res)=>{
        if(res.status === 200){
          signOut()
        }
      })
  }

  const avatar = (text,
    foregroundColor = "white",
    backgroundColor = "black") => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
  
    canvas.width = 128;
    canvas.height = 128;
  
    // Draw background
    context.fillStyle = backgroundColor;
    context.fillRect(0, 0, canvas.width, canvas.height);
  
    // Draw text
    context.font = "bold 100px sans-serif";
    context.fillStyle = foregroundColor;
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText(text, canvas.width / 2, canvas.height / 2);
  
    return canvas.toDataURL("image/png");
  }

  return (
    <Popover className="relative bg-white">
      <div className="w-full mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <NavLink to="/">
              <span className="sr-only">Workflow</span>
              <img
                className="h-8 w-auto sm:h-10"
                src={logo}
                alt=""
              />
            </NavLink>
          </div>
          <div className="-mr-2 -my-2 md:hidden">
            <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
              <span className="sr-only">Open menu</span>
              <MenuIcon className="h-6 w-6" aria-hidden="true" />
            </Popover.Button>
          </div>
          <Popover.Group as="nav" className="hidden md:flex space-x-10">
            <NavLink className={({isActive}) => isActive
              ? 'font-bold text-base text-gray-900'
              : 'text-base font-medium text-gray-500 hover:text-gray-900'} to='/'>Pagrindinis</NavLink>
            {isAuthenticated()
              && <NavLink className={({isActive}) => isActive
                ? 'font-bold text-base text-gray-900'
                : 'text-base font-medium text-gray-500 hover:text-gray-900'} to='/dashboard' end>Skydelis</NavLink>
            }
          </Popover.Group>
          <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
            {!isAuthenticated()
            /* Vartotojas neprisijungęs */
            ? <NavLink 
              className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-violet-500 hover:bg-violet-700"
              to='/login'>
                Prisijungti
            </NavLink>
            /* Vartotojas prisijungęs */
            : <Menu as="div" className="ml-3 relative">
              <div>
                <Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white gap-2 items-center">
                  <span className="sr-only">Meniu</span>
                  <img
                    className="h-8 w-8 rounded-full"
                    src={avatar(authUser().user.person.name.slice(0, 1), 'white', '#6d28d9')}
                    alt='Vartotojo nuotrauka'
                    />
                  <span className='text-white font-medium pr-2'>{authUser().user.person.name}</span>
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
                >
                <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                  <Menu.Item>
                  {({ isActive }) => (
                    <NavLink
                      to='/'
                      className={classNames(isActive ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-200')}
                      >
                      Profilis
                    </NavLink>
                  )}
                  </Menu.Item>
                  <Menu.Item>
                    <span
                      onClick={() => logOut()}
                      className={classNames('block px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-200 cursor-pointer')}
                      >
                      Atsijungti
                    </span>
                  
                  </Menu.Item>
                </Menu.Items>
              </Transition>
            </Menu>}
          </div>
        </div>
      </div>

      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel focus className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-[99]">
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <img
                    className="h-8 w-auto"
                    src={logo}
                    alt="Workflow"
                  />
                </div>
                <div className="-mr-2">
                  <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Close menu</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
              <div className="mt-6">
                <nav className="grid gap-y-8">
                  {meniuLinks.map((item) => (
                    <NavLink
                      key={item.name}
                      to={item.to}
                      className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                    >
                      <item.icon className="flex-shrink-0 h-6 w-6 text-violet-700" aria-hidden="true" />
                      <span className="ml-3 text-base font-medium text-gray-900">{item.name}</span>
                    </NavLink>
                  ))}
                </nav>
              </div>
            </div>
            <div className="py-6 px-5 space-y-6">
              <div className="grid grid-cols-2 gap-y-4 gap-x-8">
              </div>
              <div>
              {!isAuthenticated()
                ? <NavLink
                  to="/login"
                  className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-violet-500 hover:bg-violet-700"
                >
                  Prisijungti
                  <LoginIcon className="flex-shrink-0 h-6 w-6 ml-2" aria-hidden="true" />
                </NavLink>
                : <span
                  onClick={() => logOut()}
                  className={classNames('"w-full flex items-center justify-center px-4 py-2 border border-violet-500 hover:border-violet-700 rounded-md shadow-sm text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-200 cursor-pointer')}
                >
                  Atsijungti
                  <LogoutIcon className="flex-shrink-0 h-6 w-6 ml-2" aria-hidden="true" />
                </span>
                }
                {/* <p className="mt-6 text-center text-base font-medium text-gray-500">
                  Existing customer?{' '}
                  <a href="#" className="text-indigo-600 hover:text-indigo-500">
                    Sign in
                  </a>
                </p> */}
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  )
}